import { useDispatch, useSelector } from "react-redux";
import {
    closeLoginModal,
    clearPendingAction,
    loginSuccess,
} from "../store/reducers/authSlice";
import { Modal } from "antd";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";

const LoginModal1 = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loginModalOpen, pendingAction } = useSelector(
        (s) => s.auth
    );

    const login = useGoogleLogin({
        onSuccess: (credentialResponse) => {
            dispatch(loginSuccess(credentialResponse));

            if (pendingAction?.actionFn) {
                pendingAction.actionFn();
                dispatch(clearPendingAction());
            }

            dispatch(closeLoginModal());
        },
        onError: () => {
            console.log("Login Failed");
        },
    });

    return (
        // eslint-disable-next-line react/react-in-jsx-scope
        <Modal
            open={loginModalOpen}
            onCancel={() => dispatch(closeLoginModal())}
            footer={null}
            centered
            destroyOnClose
        >
            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <h6 className="m-2">
                Vous n’êtes pas connecté ou votre session a expiré.
            </h6>

            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <h4 className="mt-4 mb-4 text-center">ASSIGANTO</h4>

            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <button
                onClick={() => login()}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    width: "100%",
                    backgroundColor: "white",
                    border: "1px solid lightgray",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "500",
                }}
            >
                {/* eslint-disable-next-line react/react-in-jsx-scope */}
                <img
                    src="https://developers.google.com/identity/images/g-logo.png"
                    alt="Google Logo"
                    style={{ width: "30px", marginRight: "10px" }}
                />
                Se connecter avec Google
            </button>

            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <h6 className="mt-3 text-center">ou</h6>

            {/* eslint-disable-next-line react/react-in-jsx-scope */}
            <button
                onClick={() => navigate("/login")}
                style={{
                    padding: "10px",
                    width: "100%",
                    backgroundColor: "#2a95d1",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "white",
                }}
            >
                Retour à la page de connexion
            </button>
        </Modal>
    );
};

export default LoginModal1;
